import React from 'react'
import Sidebar from "../Sidebar/Sidebar";
import ChatArea from "./ChatArea";
import MessageBox from "./MessageBox";
import { IoMdArrowDropdown } from "react-icons/io";

const Inbox = () => {
    return (
        <>
          <div className="bg-[#F3F2EF] mt-14 ">
            <div className="container mx-auto py-8 gap-4 sm:px-6">
              <div className="flex px-2">
                <Sidebar />
                <div className="w-3/4 mx-4 bg-white h-[650px]">
                <div className="bg-white rounded-lg">
                  <div className="flex items-center w-full p-4 rounded-t-lg border-b-2 border-gray-200">
                    <div className="flex items-center w-full">
                    <h1 className="text-xl font-bold mr-2">Inbox</h1>
                    <input
                      type="text"
                      placeholder="Search"
                      className="border rounded-lg p-2 w-1/2 h-22"
                      style={{ backgroundColor: "#F3F2EF" }}
                    />
                    </div>
                    <div>
                    <button className="bg-[#F3F2EF] text-gray-700 font-semibold py-2 px-4 rounded-lg ml-4">
                      ...
                    </button>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 p-4 border-b-2 border-gray-200">
                    <button className="bg-green-700 text-white font-semibold py-1 px-5 rounded-full flex items-center">Inbox<span><IoMdArrowDropdown /></span></button>
                    <button className="bg-white text-gray-700 font-semibold py-1 px-5 rounded-full border flex items-center ">Topics<span><IoMdArrowDropdown /></span></button>
                    <button className="bg-white text-gray-700 font-semibold py-1 px-5 rounded-full border">Unread</button>
                  </div>
                  
                </div>
                <div className="flex gap-2">
                  <MessageBox />
                  <ChatArea />
                </div>
                  
                </div>
    
                
                
              </div>
            </div>
          </div>
        </>
      );
}

export default Inbox